export enum enFormViewType {
    HeritageUnit = 'HeritageUnit',
    OtherUnit = 'OtherUnit',
    EighthUnit = 'EighthUnit',

    CruisePlan = 'CruisePlan',
    CruiseEvent = 'CruiseEvent',
    EventHandle = 'EventHandle',
    EventResponse = 'EventResponse'
}
/*
附件项维护类型
1项目附件 2核准文件 3备案附件 4另行报批 99其他附件
*/
export enum enAttachSetType {
    Project = 1,
    Ratify = 2,
    Record = 3,
    Approval = 4,

    ResponsibilityDocType = 11,
    OtherUnit = 12,
    EighthUnit = 13,

    EventList = 21,//巡查事件
    EventHandle = 22,//巡查整改通知
    EventResponse = 23,//巡查整改响应

    Other = 99
}

/*
1.省文物局 2.省财政局 3.市文物局 4.市财政局 5.区县
6.评估机构 7.评估专家 8.文保单位 9.巡查人员
*/
export enum enUserType {
    /** 1省文物局 */
    ProvinceHeritage = 1, // 省文物局
    /** 2省财政局 */
    ProvinceFinance = 2, // 
    /** 3市文物局 */
    CityHeritage = 3, // 
    /** 4市财政局 */
    CityFinance = 4, // 
    /** 5区县 */
    County = 5, // 
    /** 6评估机构 */
    ReviewInstitute = 6, // 
    /** 7评估专家 */
    Expert = 7, // 评估专家
    /** 8文保单位 */
    HeritagUnit = 8, // 
    /** 9巡查人员 */
    HeritagPatrol = 9, // 
    /** 10公众用户 随手拍 */
    Snapshot = 10,
    /** 11乡镇文化站 */
    Township = 11 // 
}
export enum enUserSubType {
    /** 安全巡查 */
    Patrol = 81,
    /**公文分发 */
    GovDoc = 82
}

export enum enUnitLevel {
    Country = 1, //国保单位
    Province = 2, //省保单位
    CityCounty = 3, //市县保
    Other = 4 //其他单位
}
/*
下拉框 首选项firstType:0无，1select，2all
*/
export enum enFirstType {
    None = 0,
    Select = 1,
    All = 2,
    Empty = 3
}

/*
LookupType 枚举
enLookupType[enLookupType.AssessmentInstitute], 返回string 类型 'AssessmentInstitute'
*/
export enum enLookupType {
    /** 数据看板 日期范围 */
    DataBoard_DateRange,

    AssessmentInstitute, // 评审机构

    //#region 专家信息
    ExpertType, // 类型 1方案  2预算  3方案和预算
    Bank, // 银行(专家)
    Education, // 学历(专家)
    Positional, // 职位(专家)
    ProfessionalTech, // 专家所擅长的技术
    //#endregion

    //#region 行政区划
    Province, // 省级
    City, // 市级
    County, // 区县
    //#endregion

    //#region 文保单位
    HeritageLevel, // 单位级别
    HeritageClassify, // 文物分类
    HeritageSubClassify, // 文物子类
    InstituteType, // 机构类型
    InstituteLevel, // 机构级别
    AreaType, // 区域类型
    HeritageBatch, // 批次
    HeritageAge, // 统计年代
    UnitProperty, // 单位属性
    HeritageSaveType, // 保存方式
    HeritageSaveStatus, // 保存状态
    HumanDamageRes, // 人为损坏原因
    NaturalDamageRes, // 自然损坏原因

    //#region 所有权性质
    HeritageIndustry, // 所属行业
    OwnerNature, // 所有权性质
    HeritageUsage, // 用途
    Minority, // 少数名族
    NationalTitle, // 国家级称号
    //#endregion

    //#region 文物保护单位责任主体
    CruiseTeam, // 巡防组织名称
    Responsibility, // 责任人分类
    ResponsibilityDepartment, // 文保单位责任主体部门
    ResponsibilityPosition, // 文保单位责任主体职位
    //#endregion
    //#endregion

    EightUnitLevel,//第八批文保单位级别

    //#region 文物安全
    //#region 巡查计划
    CruiseSchedule, // 巡查间隔
    //#endregion

    //#region 事件上报(问题上报)
    EventIssueType, //事件分类
    EventIssueLevel,//事件级别
    EventIssueFrom,//事件来源

    /** 隐患分类 */
    HiddenDangerType,

    /** 隐患子类 */
    HiddenDangerSubType,
    //#endregion
    //#endregion

    //#region 批文
    OfficialDocType,//批文类型
    OfficialDocPublicType,//公开形式
    //#endregion

    //#region 保护工程
    ProjectProperties,//工程性质
    //#endregion

    //#region 保护规划
    ProtectPlanStage,//保护规划编制阶段 未作规划/规划编制立项/规划编制/规划批准实施
    //#endregion

    //#region 考古调查与发掘
    InvestigationCategory,//调查性质
    //#endregion

    //#region 安全与执法
    SafetyCheckRiskLevel,//风险等级
    //#endregion

    //#region 文保项目
    ProjectClassify, // 项目分类
    ProjectSubClassify, // 项目子类
    //#endregion

    //#region 文物设备
    DeviceCategory,//设备分类
    DeviceBrand,//设备品牌
    DeviceModuleDriver,//模拟驱动
    DevicePointValueType,//数据点值类型
    DevicePointValueUnit,//测点数据单位
    DeviceDateRange,//设备数据日期范围
    //#endregion

    //#region 文物建筑消防安全
    //评级
    UBFireSafety_RiskLevel,//风险评估级别
    //#region 表1－1 文物建筑基本信息 UnitBuildingFireSafetyList 

    /** 结构形式:纯木、砖木、石木 */
    UBFireSafety_Structure,

    /** 使用性质:
     * 展厅、办公、民居、商业、餐饮、
     * 食堂、厨房、旅馆、农家乐或民宿、仓储、废弃、堆积杂物
    */
    UBFireSafety_UsageNature,

    /** 布局形式:院落，独栋 */
    UBFireSafety_LayoutForm,

    /** 分隔方式:
     * 道路、水系、其他
    */
    UBFireSafety_SeparateType,

    /** 分隔物:
     * 院墙，外墙
    */
    UBFireSafety_SeparateBy,

    /** 可燃构件:
     * 隔墙、柱、顶棚
    */
    UBFireSafety_Combustible,
    //#endregion
    //#region 表1－2 文物建筑火灾危险源辨识 UnitBuildingFireSafetyHazardSource

    /** 是否存在以下行为？
     * 烤火、燃香、吸烟、点蚊香
    */
    UBFireSafety_HS_FireAction,

    /** 燃料种类:
     * 柴草、煤气、沼气、电、蜂窝煤
    */
    UBFireSafety_HS_FuelType,
    //#endregion
    //#region 表1－3 文物建筑消防设施设备配置使用情况 UnitBuildingFireSafetyFacilityLayout

    /** 给水形式：
     * 低压，高压，临时高压
    */
    UBFireSafety_FL_WaterSupplyForm,

    /** 传输形式:
     * 有线，无线
    */
    UBFireSafety_FL_TransferForm,

    /** 探测器类型:
     * 点式感烟、点式感温、感温光纤、红外对射、图像型、吸气式、紫外火焰、可燃气体探测
    */
    UBFireSafety_FL_DetectorType,
    //#endregion
    //#endregion

    //#region 资料(文档)管理
    DocumentCategory,//文档分类
    DocumentFrom,//文档来源
    //#endregion

    //#region 案件管理

    /** 案件来源 */
    CaseSource,

    /** 查处程序 */
    Investigat,

    /** 证书类型 */
    CertificateType,
    //#endregion

    //#region 四有情况

    /** 完残程度 */
    Four_Damaged,

    /** 质地 */
    Four_Texture,
    //#endregion

    //#region 首页快捷功能    

    /** 首页快捷功能 安全隐患 日期枚举 */
    Dashboard_EventDateRange,
    //#endregion

    //#region 视频设备

    /** 视频协议 */
    VideoProtocol,

    /** 监控点类型 */
    VideoPointType,

    /** 视频通道类型 */
    VideoChannelType,
    //#endregion

    //#region 文物督办

    /** 来源（国家文物局、省文物局、市文物局、其他） */
    SuperviseSource,
    //#endregion

    //#region 法律法规文件

    /** 法律法规文件类型 */
    LawFileClassify,
    //#endregion

    //#region mobile 手机端枚举
    DateRangeFilter,//mobile 自定义查询日期范围 1周 1个月 3个月
    EventDateRange//mobile 问题汇总日期范围
    //#endregion
}

export enum enPositionType {
    /** 1中心点坐标 */
    UnitDefault = 1,
    /** 2监控地带 */
    MonitorArea = 2,
    /** 3保护范围 */
    ProtectArea = 3,
    /** 4巡查点 */
    CruisePoint = 4,
    /** 5重点保护范围 */
    KeyProtectArea = 5,
    /** 6碑文 */
    Epigraphy = 6,
    Other = 7
}